import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import ImageIcon from '@material-ui/icons/Image';
import ListIcon from '@material-ui/icons/List';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import DynamicElementDialog from './../../../logged_out/components/dialog/DynamicElementDialog';
import { cdnURL } from 'shared/functions/api/'
import api from 'shared/functions/api/'

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SiteActions from "redux/actions/site";

import FormData from 'form-data';

const EditButton = styled(props => <IconButton className={props.className} style={props.style} onClick={props.onClick}>
  <Tooltip title={`Edit ${props.block.type}`}>
  {(() => {
    switch(props.block.type){
      case 'text': return <EditIcon />;
      case 'image': return <ImageIcon />;
      case 'list': return <ListIcon />;
    }
  })()}
  </Tooltip>
</IconButton>)`
position: absolute;
top: -34px;
left: -44px;
z-index: 10;

svg{
  color: #b08f6e;
  background-color: black;
  border-radius: 50%;
  padding: 5px;
  box-sizing: content-box;
  box-shadow: 0px 0px 8px 0px white;
  font-size: 20px;
}
`;

const LinkNoDecoration = styled(Link)`
text-decoration: none;
`;

const DynamicElement = (props) => {
  const { siteBlocks, id, to, children, authUser, style, buttonStyle } = props;

  const [openEdit, setOpenEdit] = React.useState(false);

  if ((!id || !siteBlocks[id]) && !to) return '';

  if (to) {
    return authUser && authUser.role === 'admin' ? <LinkNoDecoration to={to} style={style}>
      <Button
        variant="contained"
        color="primary"
      >
        {children}
      </Button>
    </LinkNoDecoration> : '';
  }

  const block = siteBlocks[id];
  let value = block.type === 'image' ? cdnURL + block.value : block.value;

  const editSiteBlock = () => {
    setOpenEdit(true);
  }
  const onClose = () => {
    setOpenEdit(false);
  }

  const editButtonOverImage = block.type === 'image' ? {left: -5, top: -50, ...buttonStyle} : buttonStyle;

  return <span style={{position: 'relative', ...style}}>
    {authUser && authUser.role === 'admin' && <React.Fragment>
      <EditButton block={block} onClick={editSiteBlock} style={editButtonOverImage} />
      {openEdit &&
        <DynamicElementDialog
          onClose={onClose}
          onFormSubmit={async (values) => {
           
            try {

              if (values.type === 'text') {
                // replace html P tags with 2 BR tags and remove the very last <br /><br />
                // this is so the html text doesn't get messed up in the page by the P tags which usually have padding and other css properties that we don't need
                values.value = values.value.split('<p>').join('').split('</p>').join('<br /><br />').replace(new RegExp('<br /><br />$'), '');
              }

              var formData;

              if (values.type === 'image') {
                formData = new FormData();
                for (let fieldName in values) {
                  if (fieldName === '_id') continue;
                  if (fieldName === 'value' && typeof values[fieldName] === 'object') {
                    formData.append(
                      'src',
                      new Blob([values[fieldName]], { type: values[fieldName].type }),
                      values[fieldName].name
                    );
                    formData.append(fieldName, 'File upload...');
                  } else {
                    formData.append(fieldName, values[fieldName]);
                  }
                }
              }else{
                formData = values;
              }

              //return console.log(Object.fromEntries(formData));

              let res = false;
              if (values._id) {
                res = await api.patch(`/configs/site-blocks/${values._id}`, formData);
              } else {
                res = await api.post('/configs/site-blocks', formData);
              }

              await props.fetchSiteBlocks();

              onClose();
            } catch (err) {
              console.log(err)
              const errorMessage = err.response.data.errors.msg.split('_').join(' ')
              console.log(errorMessage)
            }
          }}
          initialValues={{ _id: id, ...block }}
        />
      }
    </React.Fragment>
    }
    {block.url ? <a href={block.url} target="_blank">{children({ value })}</a> : children({ value })}
  </span>
};


export default connect(
  (state) => ({
    authUser: state.auth.user,
    siteBlocks: state.site.blocks,
  }),
  (dispatch) => bindActionCreators({ ...SiteActions }, dispatch)
)(DynamicElement);
